import PurchaseList from '../components/vender/purchaselist';

const venderRoutes = [
    { path: '/matm-order-list', component: PurchaseList, allowedRoles: ['vender'] },
];

export  default venderRoutes;
